import { FormattedMessage } from 'react-intl';

import Heading from '@atlaskit/heading';
import { Box, Inline, Stack, Text, xcss, Flex } from '@atlaskit/primitives-next';
import { token } from '@atlaskit/tokens';

import { PaperPlaneVector } from '../../../assets';

import { messages } from './messages';

const boxStyles = xcss({
	borderRadius: 'border.radius.200',
	border: `1px solid ${token('color.border.disabled')}`,
});

const iconContainerStyles = xcss({
	width: '111px',
	height: '111px',
});

export const OtherOrgsDisplay = () => {
	return (
		<Box padding="space.300" backgroundColor="elevation.surface.sunken" xcss={boxStyles}>
			<Inline space="space.400" alignBlock="center">
				<Flex xcss={iconContainerStyles} alignItems="center" justifyContent="center">
					<PaperPlaneVector />
				</Flex>
				<Stack space="space.200">
					<Heading size="small">
						<FormattedMessage {...messages.otherOrgsDisplayTitle} />
					</Heading>
					<Text>
						<FormattedMessage {...messages.otherOrgsDisplayDescription} />
					</Text>
				</Stack>
			</Inline>
		</Box>
	);
};
